import React, { useState } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import DataContainer from '../../../Shared/DataContainer';
import Icon from '../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../Shared/TextInput';
import FileInput from '../../../Shared/FileInput';
import SelectInput from '../../../Shared/SelectInput';
import TextArea from '../../../Shared/TextArea';
import LoadingButton from '../../../Shared/LoadingButton';
import { toFormData } from '../../../utils';

function Create() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          name: '',
          current_code: null,
          code: '',
          image: null,
          description: '',
          order: 0,
          maxSell: 25,
          currency: '',
          type: [],
          category: [],
          subcategory: [],
          tag: [],
          available: 0,
          alert: 0,
          price: 0,
          types: data.types || [],
          show_home: false,
          is_online: true,
          status: false
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleCategory(e, _type, tycat, catsub, tag, i) {
          e.preventDefault();
          const key = e.target.name;
          const value = e.target.value;
          // let types = [..._type];
          let elem = [];
          let b = -1;
          switch(key){
               case 'tag': elem = values.tag;
                    tag[i].check = !tag[i].check;
                    b = getParentId(catsub, tag[i], 'sid');
                    catsub[b].tags = tag;
                    tycat[getParentId(tycat, catsub[b], 'cid')].subcategory = catsub;
                    _type[getParentId(_type, tycat[getParentId(tycat, catsub[b], 'cid')], 'id')].category = tycat;
                    if(elem.indexOf(tag[i].tid) == -1){
                         elem.push(tag[i].tid);
                    }else{
                         elem.splice(elem.indexOf(tag[i].tid), 1);
                    }
                    setValues(values => ({
                         ...values,
                         tag: elem,
                         types: _type
                    }));
                    break;
               case 'subcategory': elem = values.subcategory;
                    catsub[i].check = !catsub[i].check;
                    b = getParentId(tycat, catsub[i], 'cid');
                    tycat[b].subcategory = catsub;
                    _type[getParentId(_type, tycat[b], 'id')].category = tycat;
                    if(elem.indexOf(catsub[i].sid) == -1){
                         elem.push(catsub[i].sid);
                    }else{
                         elem.splice(elem.indexOf(catsub[i].sid), 1);
                    }
                    setValues(values => ({
                         ...values,
                         subcategory: elem,
                         types: _type
                    }));
                    break;
               case 'category' : elem = [...values.category];
                    tycat[i].check = !tycat[i].check;
                    b = getParentId(_type, tycat[i], 'id');
                    _type[b].category = tycat;
                    if(elem.indexOf(tycat[i].cid) == -1){
                         elem.push(tycat[i].cid);
                    }else{
                         elem.splice(elem.indexOf(tycat[i].cid), 1);
                    }
                    setValues(values => ({
                         ...values,
                         category: elem,
                         types: _type
                    }));
                    break;
               case 'type': elem = values.type;
                    _type[i].check = !_type[i].check;
                    if(elem.indexOf(_type[i].id) == -1){
                         elem.push(_type[i].id);
                    }else{
                         elem.splice(elem.indexOf(_type[i].id), 1);
                    }
                    setValues(values => ({
                         ...values,
                         type: elem,
                         types: _type
                    }));
                    break;
          }
     }

     function getParentId(parent, value, pref) {
          let index = -1;
          for(var i = 0; i < parent.length; i++){
               if(parent[i][pref] == value.parent){
                    index = i;
                    break;
               }
          }
          return index;
     }

     function getIndex(object, id){
          let index = -1;
          for(var i = 0; i < object.length; i++){
               if(object[i].id == id){
                    index = i;
                    break;
               }
          }
          return index;
     }

     function handleFileChange(file, path) {
          setValues(values => ({
               ...values,
               image: file
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          const formData = toFormData(values, 'POST');
          Inertia.post(route('product.store'), formData).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="permission-c">
               <Helmet>
                    <title>Products</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-medium text-gray-900">Create Product</h3>
                              <p className="mt-1 text-sm text-gray-600">
                                   Use this form to enter all information relative to a single product. Keep in my that most data you enter here will be available to the client visiting the website
                              </p>
                         </div>
                    </div>
                    <DataCard>
                         <form onSubmit={handleSubmit}>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('product.index')} className="inline-flex items-center p-2 text-sm text-gray-500 bg-transparent border border-gray-500 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="col-span-6 sm:col-span-4">
                                             <label className="block text-sm font-medium text-gray-700" htmlFor="photo">
                                                  <span>Image</span>
                                             </label>
                                             <div className="mt-2">
                                                  <img src={`https://ui-avatars.com/api/?name=Produit&amp;color=7F9CF5&amp;background=EBF4FF`} className="w-20 h-20 rounded-full" />
                                             </div>
                                             <FileInput
                                                  className="w-full lg:w-1/2"
                                                  label="Select Picture"
                                                  name="image"
                                                  accept="image/.jpg,.jpeg,.png"
                                                  errors={errors.image}
                                                  value={values.image}
                                                  onChange={handleFileChange}
                                              />
                                             <TextInput
                                                   className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                   label="Name"
                                                   name="name"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.name}
                                                   value={values.name}
                                                   onChange={handleChange}
                                              />
                                              <TextInput
                                                   className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                   label="Code"
                                                   name="code"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   errors={errors.code}
                                                   value={values.code}
                                                   onChange={handleChange}
                                              />
                                             <div className="w-full mt-4">
                                                  <label className="block text-sm font-medium text-gray-700" htmlFor="category">
                                                       Category <span className="text-red-700">*</span>
                                                  </label>
                                                  <ul className="h-64 p-2 overflow-auto list-none border border-gray-200 rounded">
                                                       {values.types.map((type, t) => {
                                                            return <li className={`mt-1`} key={`t-${type.id}`}>
                                                                 <label className={`p-2 flex items-center rounded hover:bg-gray-200 hover:shadow-md ${(type.check?'bg-blue-200':'')}`} htmlFor="type">
                                                                      <input name="type" id="type" className="form-checkbox" type="checkbox" value={type.id} checked={type.check} onChange={e=>handleCategory(e, values.types, null, null, null, t)}/>
                                                                      <span className="ml-2 text-sm text-gray-800">{type.name}</span>
                                                                 </label>
                                                                 <ul className="ml-8">
                                                                      {type.category.map((categ, c) => {
                                                                           return <li className={`mt-1`} key={`c-${categ.cid}`}>
                                                                                <label className={`p-2 flex items-center rounded hover:bg-gray-200 hover:shadow-md ${(categ.check?'bg-blue-200':'')}`} htmlFor="category">
                                                                                     <input name="category" id="category" className="form-checkbox" type="checkbox" value={categ.cid} checked={categ.check} onChange={e=>handleCategory(e, values.types, type.category, null, null, c)}/>
                                                                                     <span className="ml-2 text-sm text-gray-800">{categ.name}</span>
                                                                                </label>
                                                                                <ul className="ml-8">
                                                                                    {categ.subcategory.map((subs, s) => {
                                                                                         return <li className={`mt-1`} key={`sc-${subs.sid}`}>
                                                                                              <label className={`p-2 flex items-center rounded hover:bg-gray-200 hover:shadow-md ${(subs.check?'bg-blue-200':'')}`} htmlFor="subcategory">
                                                                                                   <input name="subcategory" id="subcategory" className="form-checkbox" type="checkbox" value={subs.sid} checked={subs.check} onChange={e=>handleCategory(e, values.types, type.category, categ.subcategory, null, s)}/>
                                                                                                   <span className="ml-2 text-sm text-gray-800">{subs.name}</span>
                                                                                              </label>
                                                                                              <ul className="ml-8">
                                                                                                   {subs.tags.map((tag, tg) => {
                                                                                                        return <li className={`mt-1`} key={`tg-${tag.tid}`}>
                                                                                                               <label className={`p-2 flex items-center rounded hover:bg-gray-200 hover:shadow-md ${(tag.check?'bg-blue-200':'')}`} htmlFor="tag">
                                                                                                                   <input name="tag" id="tag" className="form-checkbox" type="checkbox" value={tag.tid} checked={tag.check} onChange={e=>handleCategory(e, values.types, type.category, categ.subcategory, subs.tags, tg)}/>
                                                                                                                   <span className="ml-2 text-sm text-gray-800">{tag.name}</span>
                                                                                                              </label>
                                                                                                         </li>
                                                                                                    })}
                                                                                               </ul>
                                                                                         </li>
                                                                                    })}
                                                                               </ul>
                                                                          </li>
                                                                      })}
                                                                 </ul>
                                                            </li>
                                                       })}
                                                  </ul>
                                             </div>
                                              <TextArea
                                                  className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                  label="Description"
                                                  name="description"
                                                  errors={errors.description}
                                                  value={values.description}
                                                  onChange={handleChange}
                                             />
                                             <TextInput
                                                  className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                  label="Order"
                                                  name="order"
                                                  type="number"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.order}
                                                  value={values.order}
                                                  onChange={handleChange}
                                             />
                                             <SelectInput
                                                 className="block w-full mt-4 leading-tight text-gray-700 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500"
                                                 label="Currency"
                                                 name="currency"
                                                 errors={errors.currency}
                                                 value={values.currency}
                                                 onChange={handleChange}
                                             >
                                                 <option value=""></option>
                                                 {data.currencies.map(({id, name, short_code}) => {
                                                      return <option key={id} value={id}>{name+' ('+short_code+')'}</option>
                                                 })}
                                             </SelectInput>
                                             <TextInput
                                                  className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                  label="Qty Available"
                                                  name="available"
                                                  type="number"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.available}
                                                  value={values.available}
                                                  onChange={handleChange}
                                             />
                                             <TextInput
                                                  className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                  label="Qty to Alert"
                                                  name="alert"
                                                  type="number"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.alert}
                                                  value={values.alert}
                                                  onChange={handleChange}
                                             />
                                             <TextInput
                                                 className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                 label="Price"
                                                 name="price"
                                                 type="number"
                                                 disable={false}
                                                 readonly={false}
                                                 errors={errors.price}
                                                 value={values.price}
                                                 onChange={handleChange}
                                            />
                                            <TextInput
                                                className="block w-full mt-4 rounded-md shadow-sm form-input"
                                                label="Max Qty Allowed per Sale"
                                                name="maxSell"
                                                type="number"
                                                disable={false}
                                                readonly={false}
                                                errors={errors.maxSell}
                                                value={values.maxSell}
                                                onChange={handleChange}
                                           />
                                            <label className="block w-full mt-4 rounded-md shadow-sm form-input" htmlFor="perms">
                                                 <input name="status" className="form-checkbox" type="checkbox" value={values.status} checked={values.status} onChange={handleChange}/>
                                                 <span className="ml-2 text-sm text-gray-800">Active</span>
                                            </label>
                                            <label className="block w-full mt-4 rounded-md shadow-sm form-input" htmlFor="perms">
                                                 <input name="show_home" className="form-checkbox" type="checkbox" value={values.show_home} checked={values.show_home} onChange={handleChange}/>
                                                 <span className="ml-2 text-sm text-gray-800">Show on Home Page</span>
                                            </label>
                                            <label className="block w-full mt-4 rounded-md shadow-sm form-input" htmlFor="perms">
                                                 <input name="is_online" className="form-checkbox" type="checkbox" value={values.is_online} checked={values.is_online} onChange={handleChange}/>
                                                 <span className="ml-2 text-sm text-gray-800">Available Online</span>
                                            </label>
                                        </div>
                                   </div>
                              </div>
                              <div className="flex items-center justify-end px-4 py-3 text-right bg-gray-100 rounded-b sm:px-6">
                                   <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 ml-4 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25">
                                        Save
                                   </LoadingButton>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Create.layout = page => <AdminLayout children={page} header={'Create Product'} />;

export default Create;
